const list = document.getElementById('introduceList');
const moreButton = document.getElementById('js-button-more-introduce');
const mediaQueryList = window.matchMedia('(max-width: 767px)');
let hideNum;
const listener = (event) => {
  if (event.matches) {
    // SP
    moreButton.textContent = `もっと見る`;
    moreButton.classList.remove('active');
    hideNum = 2;
    ResizeInit();
  } else {
    // PC
    moreButton.textContent = `もっと見る`;
    moreButton.classList.remove('active');
    hideNum = 4;
    ResizeInit();
  }
};

function ResizeInit() {
  for (let i = 0; i < list.children.length; i++) {
    list.children[i].classList.remove('is-hide');
    if (i >= hideNum) {
      list.children[i].classList.add('is-hide');
    }
  }
}

function showMore() {
  moreButton.addEventListener('click', function (e) {
    for (let i = 0; i < list.children.length; i++) {
      if (list.children[i].classList.contains('is-hide')) {
        list.children[i].classList.remove('is-hide');
        moreButton.textContent = `閉じる`;
        moreButton.classList.add('active');
      } else {
        if (i >= hideNum) {
          list.children[i].classList.add('is-hide');
          moreButton.textContent = `もっと見る`;
          moreButton.classList.remove('active');
        }
      }
    }
    e.preventDefault();
  });
}

showMore();

// リスナー登録
mediaQueryList.addEventListener('change', listener);
// 初期化処理
listener(mediaQueryList);
